import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useAppSelector } from '@/store';
import { RNButton } from '@/components';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { PAYMENT_ERROR_CARD_STYLES } from '../../common/cardStyleConstants';

interface Props {
  leaseId: number;
  isConnection: boolean;
  onRefresh: () => void;
}

export const ChargeSummaryErrorCard: React.FC<Props> = ({ leaseId, isConnection, onRefresh }) => {
  const authUser = useAppSelector((s) => s.auth.user as any);
  const connections = useAppSelector((s) => (s.home.linkedAccounts as any[]) || []);

  const connectedUser = useMemo(() => {
    if (!isConnection) return null;
    return connections.find((conn: any) => Array.isArray(conn?.leaseIds) && conn.leaseIds.includes(leaseId)) || null;
  }, [connections, leaseId, isConnection]);

  const user = connectedUser?.user || authUser || {};
  const firstName = user?.firstName || 'Resident';
  const lastName = user?.lastName || '';

  return (
    <View style={styles.card}>
      <View style={styles.row}>
        <View style={styles.iconWrap}>
          <RESIDENTS_SVG_COMPONENTS.WARNING width={20} height={20} />
        </View>
        <View style={styles.textCol}>
          <Text style={styles.title}>{`${firstName} ${lastName}`.trim()}</Text>
          <Text style={styles.subtitle}>Unable to load lease information</Text>
          <Text style={styles.caption}>Please try again later</Text>
        </View>
        <RNButton
          title="Refresh"
          onPress={onRefresh}
          style={styles.refreshBtn}
          icon={<RESIDENTS_SVG_COMPONENTS.REFRESH width={16} height={16} />}
          iconPosition="left"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    marginHorizontal: 8,
    marginBottom: PAYMENT_ERROR_CARD_STYLES.MARGIN_BOTTOM,
    borderRadius: 12,
    backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND,
    minHeight: PAYMENT_ERROR_CARD_STYLES.MIN_HEIGHT,
    paddingVertical: PAYMENT_ERROR_CARD_STYLES.PADDING_VERTICAL,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
  },
  iconWrap: {
    width: 60,
    height: 60,
    borderRadius: 30,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: RESIDENTS_DESKTOP_COLORS.CIRCLE_ICON_BACKGROUND,
    marginRight: 18,
  },
  textCol: {
    flex: 1,
  },
  title: {
    fontSize: 16,
    fontWeight: '800',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 6,
  },
  subtitle: {
    fontSize: 12,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 4,
  },
  caption: {
    fontSize: 12,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
  },
  refreshBtn: {
    marginLeft: 12,
  },
});

export default ChargeSummaryErrorCard;


